<template>
  <v-app-bar class="app-bar" app color="#2f4051" dark height="80px">
    <div class="d-flex align-center">
      <a href="/">
        <v-img
          alt="Vuetify Logo"
          class="app-logo mt-4 mb-4"
          light
          contain
          src="/public/ideagen_compliSpace_vertical.svg"
          transition="scale-transition"
        ></v-img>
      </a>
    </div>

    <v-spacer></v-spacer>

    <TopUserMenu v-if="userMenuDisplayed"></TopUserMenu>
  </v-app-bar>
</template>

<script>
import TopUserMenu from './TopUserMenu';

export default {
  components: {
    TopUserMenu
  },

  computed: {
    userMenuDisplayed() {
      return this.$store.state.sessionUser && this.$store.state.sessionUser.email;
    }
  }
};
</script>
<style scoped>
.app-bar >>> .v-toolbar__content {
  padding: 0;
}

.app-logo {
  margin-left: 26px;
}
</style>
